module.exports = __webpack_public_path__ + "static/media/ico_play.9a6eb834.svg";